import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import SeoHead from '@/components/feature/SeoHead';
import BackToTop from '@/components/feature/BackToTop';
import PageHero from '@/components/feature/PageHero';
import AboutIntro from '@/pages/about/components/AboutIntro';
import PrinciplesSection from '@/pages/about/components/PrinciplesSection';
import MilestonesSection from '@/pages/about/components/MilestonesSection';
import TestimonialsSection from '@/pages/about/components/TestimonialsSection';
import AboutCta from '@/pages/about/components/AboutCta';
import { aboutPrinciples } from '@/mocks/siteData';

const aboutStructuredData = [
  {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们｜深瞳爆料官网',
    url: 'https://shentong-baoliao.com/about',
    inLanguage: 'zh-CN',
    description:
      '深瞳爆料官网关于我们页面，介绍平台定位、内容原则、发展节点与用户口碑，并说明信源保护与事实核查标准。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '深瞳爆料',
    url: 'https://shentong-baoliao.com/',
    email: 'contact@shentong-baoliao.com',
    foundingDate: '2019',
    description:
      '以信源保护为优先的调查线索汇集平台，通过官方邮箱与匿名通道接收公众线索。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://shentong-baoliao.com/' },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
        item: 'https://shentong-baoliao.com/about',
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: '深瞳爆料内容原则',
    itemListElement: aboutPrinciples.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.title,
      description: item.desc,
    })),
  },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SeoHead
        title="关于我们｜平台定位与内容原则 - 深瞳爆料官网"
        description="了解深瞳爆料官网的品牌定位、内容原则、发展节点与用户口碑。平台以信源保护优先、事实核查为底线，通过官方邮箱与匿名通道接收公众线索。"
        keywords="爆料官网关于我们,平台定位,内容原则,信源保护,事实核查"
        path="/about"
        structuredData={aboutStructuredData}
      />
      <SiteHeader />
      <main className="flex-1">
        <PageHero
          kicker="About ShenTong"
          title="关于深瞳爆料"
          description="一个以信源保护为优先的调查线索汇集平台。我们整理、核实并推动信息进入公共视野，也把方法开放给愿意一起把事实说清楚的协作者。"
          crumbs={[{ label: '首页', to: '/' }, { label: '关于我们' }]}
        />
        <AboutIntro />
        <PrinciplesSection />
        <MilestonesSection />
        <TestimonialsSection />
        <AboutCta />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}